import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { SvgIcon } from "@progress/kendo-react-common";
import { warningCircleIcon } from "@progress/kendo-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { closeErrorDialog } from "../../slices/errorDialogSlice";

export default function ErrorDialog() {
  const dispatch = useDispatch();
  const { open, message } = useSelector((state) => state.errorDialog);

  if (!open) return null;

  const formatMessages = (msg) => {
    if (!msg) return [];
    return msg
      .split(/\r?\n/)
      .filter((line) => line.trim())
      .map((line) => line.trim());
  };

  const messages = formatMessages(message);
  const isMultipleMessages = messages.length > 1;

  return (
    <Dialog
      title={null}
      onClose={() => dispatch(closeErrorDialog())}
      width={550}
      height={isMultipleMessages ? 400 : "auto"}>
      <div className="d-flex flex-column align-items-center px-4 py-4">
        <div className="d-flex align-items-center mb-3">
          <SvgIcon
            icon={warningCircleIcon}
            style={{
              width: "32px",
              height: "32px",
            }}
            color="#da4f49"
          />
          <h2 className="fw-semibold ms-2 mb-0" style={{ color: "#7d7ab4" }}>
            Error
          </h2>
        </div>

        <div
          className="w-100 text-start rounded-3"
          style={{
            maxHeight: isMultipleMessages ? "215px" : "none",
            overflowY: "auto",
            padding: "16px",
            backgroundColor: "#f8f9fa",
            border: "1px solid #dee2e6",
          }}>
          {isMultipleMessages ? (
            <ul className="list-unstyled mb-0">
              {messages.map((msg, index) => (
                <li
                  key={index}
                  className="mb-2 pb-2"
                  style={{
                    borderBottom:
                      index < messages.length - 1 ? "1px solid #dee2e6" : "none",
                  }}>
                  <div className="d-flex align-items-start">
                    <span
                      className="fs-sm badge bg-danger me-2 mt-1 d-flex align-items-center justify-content-center"
                      style={{ minWidth: "20px" }}>
                      {index + 1}
                    </span>
                    <span className="text-secondary">{msg}</span>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-secondary mb-0">{message}</p>
          )}
        </div>
      </div>
      <DialogActionsBar>
        <div className="dialog-footer">
          <button
            className="common-btn me-4"
            onClick={() => dispatch(closeErrorDialog())}>
            Close
          </button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
}
